import "./Logo.css";

interface LogoProps {
  displayedLogo: string | null;
  displayedLabel?: string | undefined;
  corners?: "default" | "rounded";
}

export const Logo = ({ displayedLogo, displayedLabel, corners }: LogoProps): JSX.Element => {
  return (
    <div className="LogoContainerLabel">
      {displayedLogo && (
        <div>
          <label htmlFor={displayedLabel}>{displayedLabel}</label>
          <div className={`LogoContainer ${corners}`}>
            <img aria-labelledby="logo" src={displayedLogo} alt="LogoImage" />
          </div>
        </div>
      )}
    </div>
  );
};
